import {
  DeletePayload,
  PostPayload,
  PutPayload,
} from "../../../../model/http-crud-models";
import { OrganizationKeyName } from "../../../../model/Organization";
import { httpClient } from "../../../../service/http";
import {
  ProductGroupListItem,
  ProductGroupMutationPayload,
} from "../models/ProductGroup";

export const productGroupsHttp = {
  getProductGroups: async (organizationKeyName?: OrganizationKeyName) => {
    return httpClient<ProductGroupListItem[]>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/campaign-product-groups`,
    });
  },

  getProductGroup: async (
    organizationKeyName?: OrganizationKeyName,
    id?: string
  ) => {
    const resources = await httpClient<ProductGroupListItem[]>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/campaign-product-groups`,
    });

    return resources.find((item) => item.id === id);
  },

  createProductGroup: async ({
    data,
    organizationKeyName,
  }: PostPayload<ProductGroupMutationPayload>) => {
    return httpClient<ProductGroupListItem>({
      method: "POST",
      url: `/organizations/${organizationKeyName}/campaign-product-groups`,
      data,
    });
  },

  updateProductGroup: async ({
    data: { id, ...rest },
    organizationKeyName,
  }: PutPayload<ProductGroupMutationPayload>) => {
    return httpClient<ProductGroupListItem>({
      method: "PUT",
      url: `/organizations/${organizationKeyName}/campaign-product-groups/${id}`,
      data: rest,
    });
  },

  deleteProductGroup: async ({
    data: { id },
    organizationKeyName,
  }: DeletePayload) => {
    return httpClient({
      method: "DELETE",
      url: `/organizations/${organizationKeyName}/campaign-product-groups/${id}`,
    });
  },
};
